module.exports = __webpack_public_path__ + "img/8.83e790f3.jpg";